import { Model, Attr, BelongsTo } from 'spraypaint'

import ApplicationRecord from '@/models/ApplicationRecord'
import { Caretaker } from '@/models/index'

@Model()
export default class MultiChoiceCardOrder extends ApplicationRecord {
  static jsonapiType = 'multi_choice_card_orders'

  @Attr() id!: string
  @Attr() number!: string
  @Attr() createdAt!: string

  @BelongsTo() caretaker!: Caretaker
}
